import { useState } from 'react';
import CoursesDashboard from '@/components/courses/CoursesDashboard';
import CourseViewer from '@/components/courses/CourseViewer';
import { Course } from '@/types/course';

type CourseViewType = 'dashboard' | 'viewer';

export default function Courses() {
  const [viewType, setViewType] = useState<CourseViewType>('dashboard');
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);

  const handleSelectCourse = (course: Course) => {
    setSelectedCourse(course);
    setViewType('viewer');
  };

  const handleBack = () => {
    setViewType('dashboard');
    setSelectedCourse(null);
  };

  return (
    <div>
      {viewType === 'dashboard' && (
        <div className="min-h-screen bg-background p-6">
          <div className="max-w-7xl mx-auto">
            <CoursesDashboard onSelectCourse={handleSelectCourse} />
          </div>
        </div>
      )}

      {viewType === 'viewer' && selectedCourse && (
        <CourseViewer course={selectedCourse} onBack={handleBack} />
      )}
    </div>
  );
}
